<template lang="pug">
    el-radio-group(v-model="radioValue",style="margin-top: -7px;")
      el-row(v-for="item in list", :key="item.key").radio
        el-radio(:label="item.key", @change="changeRadio") {{ item.value }}
      el-row.radio(style="margin-top: 7px;")
        el-radio(label="other", @change="changeRadio") อื่นๆ
          el-input(:disabled="isDisable",
            v-model="input",
            @change="changeInput",
            style="padding-left: 30px;"
          )
</template>

<style lang="scss" scoped>
.radio {
  margin-top: 15px;
  margin-left: 0px;
  font-size: 16px;
}

</style>

<script>
export default {
  name: 'GroupRadioWithExtraOption',
  props: {
    value: [String, Number],
    list: {
      type: Array,
      required: true,
    },
  },
  data () {
    return {
      input: '',
      radioValue: '',
      isDisable: true,
    }
  },
  watch: {
    value (newVal, oldVal) {
      this.classifyRadioSelection()
    },
  },
  methods: {
    changeInput (value) {
      if (this.radioValue === 'other') {
        this.$emit('update:value', this.input)
      }
    },
    changeRadio (value) {
      this.radioValue = value
      if (this.radioValue !== 'other') {
        this.$emit('update:value', this.radioValue)
        this.isDisable = true
        this.input = null
      } else {
        this.isDisable = false
        this.input = null
        this.$emit('update:value', this.input)
      }
    },
    classifyRadioSelection () {
      let notInList = true
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].key === this.value) {
          notInList = false
          break
        }
      }
      if (notInList) {
        this.isDisable = false
        this.input = this.value
        this.radioValue = 'other'
      } else {
        this.radioValue = this.value
      }
    },
  },
}
</script>
